import pvhApi from '@/api/pvhApi'
import axios from 'axios'
import { config, url } from '@/store'

const state = () => ({
  tableHeaders: {
    allActive: false,
    headers: [
      {
        title: 'Имя',
        isSortable: true,
        sortName: 'name',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Фамилия',
        isSortable: true,
        sortName: 'surname',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Отчество',
        isSortable: true,
        sortName: 'patronymic',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Адрес',
        isSortable: false
      },
      {
        title: 'Телефон',
        isSortable: false
      },
      {
        title: 'Откуда узнал',
        isSortable: true,
        sortName: 'informer.name',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Создано',
        isSortable: true,
        sortName: 'created_at',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Изменено',
        isSortable: true,
        sortName: 'updated_at',
        dispatchName: '[pvh] getClientSort'
      },
      {
        title: 'Комментарий',
        isSortable: false
      }
    ]
  },
  clients: [
    {
      id: 1,
      isControlsActive: false,
      isActive: false,
      name: '',
      surname: '',
      patronymic: '',
      address: '',
      phone: '',
      informer: '',
      comment: '',
      created_at: ''
    }
  ],
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  sort: {},
  searchValue: '',
  filter: {
    active: false
  },
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  responseModalWithTreaties: {
    isActive: false,
    title: 'Ошибка!',
    text: '',
    type: 'main'
  },
  isActiveDelete: false
})

const getters = {
  '[pvh] getClientList': state => state.clients,
  '[pvh] getClientListTableHeaders': state => state.tableHeaders,
  '[pvh] getClientListIsLoading': state => state.isLoading,
  '[pvh] getClientListSearchValue': state => state.searchValue,
  '[pvh] getClientListFilter': state => state.filter,
  '[pvh] getClientListPagination': state => state.pagination,
  '[pvh] getClientListResponseModal': state => state.responseModal,
  '[pvh] getClientListResponseModalWithTreaties': state => state.responseModalWithTreaties,
  '[pvh] getClientListActiveDelete': state => state.isActiveDelete
}

const mutations = {
  '[pvh] GET_CLIENT_LIST': (state, clients) => {
    state.clients = clients.data.map(client => {
      return {
        ...client,
        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  '[pvh] SHOW_CLIENT_LIST_MODAL': (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedClientList = state.clients
        .filter(client => {
          return client.id === itemId
        })
        .pop()

      state.modal.updatedId = itemId
      state.modal.name = selectedClientList.name
    }
  },
  '[pvh] SET_CLIENT_LIST_ITEM_NAME': (state, value) => {
    state.modal.name = value
  },
  '[pvh] SET_CLIENT_LIST_ITEM_VALIDATION': (state, valid) => {
    if (valid.name) {
      state.modal.validation.name.message = valid.name[0]
      state.modal.validation.name.type = 'error'
    }
  },
  '[pvh] CLEAR_CLIENT_LIST_MODAL_VALIDATION': (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = {
          type: null,
          message: ''
        }
        break
      default:
        break
    }
  },
  '[pvh] CLOSE_CLIENT_LIST_MODAL': state => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = {
      id: null,
      message: ''
    }
  },

  // sort
  '[pvh] SET_CLIENT_LIST_SORT': (state, sortOptions) => {
    state.sort = sortOptions
  },

  // pagination
  '[pvh] SET_CLIENT_LIST_PAGINATION': (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  '[pvh] RESET_CLIENT_LIST_CURRENT_PAGE': state => {
    state.pagination.currentPage = 1
  },
  '[pvh] SET_CURRENT_PAGE': (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  '[pvh] SET_CLIENT_LIST_SEARCH_VALUE': (state, searchValue) => {
    state.searchValue = searchValue
  },

  // filter
  '[pvh] TOGGLE_CLIENT_LIST_FILTER': state => {
    state.filter.active = !state.filter.active
  },

  // delete checked items
  '[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_SUCCESS': (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили клинта(ов)'
    state.responseModal.type = 'main'
  },
  '[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении клиента произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },

  '[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_TREATIES_ERROR': (state, errorItems) => {
    let listNamesErrorItems = ''
    errorItems.forEach(e => {
      listNamesErrorItems += ` ${e.name}`
    })
    state.responseModalWithTreaties.isActive = true
    state.responseModalWithTreaties.text = `Данные клиенты используются:${listNamesErrorItems}`
  },
  '[pvh] CLOSE_DELETE_CLIENT_LIST_MODAL': (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  '[pvh] CLOSE_DELETE_CLIENT_LIST_MODAL_WITH_TREATIES': (state) => {
    state.responseModalWithTreaties.isActive = false
    state.responseModalWithTreaties.text = ''
  },
  '[pvh] TOGGLE_CLIENT_LIST_ITEM_ACTIVE': (state, itemId) => {
    const itemsLength = state.clients.length
    let counter = 0

    state.clients.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  '[pvh] TOGGLE_CLIENT_LIST_ITEM_ACTIVE_ALL': (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.clients.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  '[pvh] RESET_CLIENT_LIST_ALL_CHECKS': (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.clients.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  // reset store
  '[pvh] RESET_CLIENT_LIST_STORE': (state) => {
    // state.searchValue = ''
    state.sort = {}
    // state.filter = {}
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  '[pvh] getClientList' ({ commit, state }) {
    const params = {
      expand: 'name,surname,patronymic,address,phone,informer,comment,created_at',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[all]': state.searchValue ? `${state.searchValue}` : ''
    }

    axios.get(`${url}/pvc-client`, { params, ...config }).then(response => {
      commit('[pvh] GET_CLIENT_LIST', response.data)
      commit('[pvh] SET_CLIENT_LIST_PAGINATION', response.headers)
      state.isLoading = false
    })
      .catch(error => {
        console.log('Ошибка получения списка клиентов', error)
      })
  },

  '[pvh] toggleClientListItemActive' ({ commit }, itemId) {
    commit('[pvh] TOGGLE_CLIENT_LIST_ITEM_ACTIVE', itemId)
  },
  '[pvh] toggleClientListItemActiveAll' ({ commit }) {
    commit('[pvh] TOGGLE_CLIENT_LIST_ITEM_ACTIVE_ALL')
  },
  '[pvh] showClientListModal' ({ commit }, itemId) {
    commit('[pvh] SHOW_CLIENT_LIST_MODAL', itemId)
  },
  '[pvh] setClientListItemName' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_LIST_ITEM_NAME', value)
  },
  '[pvh] clearClientListModalValidation' ({ commit }, inputName) {
    commit('[pvh] CLEAR_CLIENT_LIST_MODAL_VALIDATION', inputName)
  },
  '[pvh] closeClientListModal' ({ commit }) {
    commit('[pvh] CLOSE_CLIENT_LIST_MODAL')
  },
  '[pvh] removeClientList' ({ commit }, itemId) {
    pvhApi.deleteClientList(itemId)
      .then(response => {
        this.dispatch('[pvh] getClientList')
      })
      .catch(error => {
        console.log('Ошибка удаления клиента:' + error)
      })
  },

  // pagination
  '[pvh] getClientListPage' ({ dispatch, commit }, pageNum) {
    commit('[pvh] SET_CURRENT_PAGE', pageNum)
    dispatch('[pvh] getClientList')
  },

  // search
  '[pvh] setClientListSearchValue' ({ commit }, searchValue) {
    commit('[pvh] SET_CLIENT_LIST_SEARCH_VALUE', searchValue)
    commit('[pvh] RESET_CLIENT_LIST_CURRENT_PAGE')
    this.dispatch('[pvh] getClientList')
  },

  // sort
  '[pvh] getClientSort' ({ commit, dispatch }, sort) {
    commit('[pvh] SET_CLIENT_LIST_SORT', sort)
    dispatch('[pvh] getClientList')
  },

  // delete checked items
  '[pvh] deleteClientListCheckedItems' ({ commit, state }) {
    const checkedItems = []
    const errorItems = []
    const treatiesItems = []
    state.clients.forEach((e) => {
      if (e.isActive && e.orders === null) {
        checkedItems.push(e)
      } else if (e.isActive && e.orders.length > 0) {
        treatiesItems.push(e)
      }
    })

    if (treatiesItems.length > 0) {
      commit('[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_TREATIES_ERROR', treatiesItems)
      commit('[pvh] RESET_CLIENT_LIST_ALL_CHECKS')

      treatiesItems.forEach((e) => {
        e.isActive = false
      })
    }

    async function processMessages (array) {
      for (const item of array) {
        await pvhApi.deleteClientList(item.id).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления клиента', error)
        })
      }
    }

    if (checkedItems.length > 0) {
      processMessages(checkedItems).then(() => {
        if (errorItems.length > 0) {
          commit('[pvh] RESET_CLIENT_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_ERROR', errorItems)
          this.dispatch('[pvh] getClientList')
        } else {
          commit('[pvh] RESET_CLIENT_LIST_ALL_CHECKS')
          commit('[pvh] DELETE_CLIENT_LIST_CHECKED_ITEMS_SUCCESS')
          this.dispatch('[pvh] getClientList')
        }
      })
    }
  },
  '[pvh] closeClientListDeleteModal' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_CLIENT_LIST_MODAL')
  },
  '[pvh] closeListDeleteModalWithTreaties' ({ commit }) {
    commit('[pvh] CLOSE_DELETE_CLIENT_LIST_MODAL_WITH_TREATIES')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
